import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=289c341f"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports